import axios from "axios";
import defaultSetting from "./defaultSetting";

let serviceBaseUrl = "";
var apiName =
  process.env.VUE_APP_ENV === "hw" ? "/xrlauncherhwapi" : "/xrlauncherapi"; // 接口前缀
process.env.NODE_ENV === "production"
  ? (serviceBaseUrl = `${defaultSetting.xrlauncherPath}${apiName}`)
  : (serviceBaseUrl = apiName);
const service = axios.create({
  // withCredentials: true, // send cookies when cross-domain requests
  baseURL: serviceBaseUrl, // url = base url + request url
  timeout: 5000, // request timeout
});
export default service;
